<template>
  <div class="new-main">
    <div class="news-tabs">
      <button
        @click="activeTab = '轻蜓资产云'"
        :class="{ active: activeTab === '轻蜓资产云' }"
      >
        {{ $t("product5") }}
      </button>
      <button
        @click="activeTab = '海康助农牧云'"
        :class="{ active: activeTab === '海康助农牧云' }"
      >
        {{ $t("product7") }}
      </button>
    </div>
    <!-- 轻蜓资产云 -->
    <div v-if="activeTab === '轻蜓资产云'" >

      <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("product12") }}</div>
         <div class="img-box">
          <img src="../assets/img/soft1.png" class="img-li-two" />
        </div>
      </div>
    </div>

  
     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-one">
          <img src="../assets/img/an24.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("product13") }}</div>
          <p class="solution-title-one">{{ $t("product16") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an25.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("product14") }}</div>
          <p class="solution-title-one">{{ $t("product17") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an26.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("product15") }}</div>
          <p class="solution-title-one">{{ $t("product18") }}</p>
        </div>
      </div>
    </div>

       <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("product9") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

       <div class="ServiceProcess-contact">
      <div class="contact-box">
        <div class="mg20">
          <span class="title-two">{{ $t("product10") }}</span>
        </div>
        <div>
          <form @submit.prevent="handleSubmit">
            <div>
              <label for="companyName">{{ $t("ServiceProcess22") }}:</label>
              <input
                type="text"
                id="companyName"
                v-model="companyName"
                
              />
            </div>
            <div>
              <label for="contactPerson">{{ $t("ServiceProcess23") }}:</label>
              <input
                type="text"
                id="contactPerson"
                v-model="contactPerson"
                
              />
            </div>
            <div>
              <label for="contactInfo">{{ $t("ServiceProcess24") }}:</label>
              <input
                type="text"
                id="contactInfo"
                v-model="contactInfo"
                
              />
            </div>
            <div>
              <label for="requirements">{{ $t("ServiceProcess25") }}:</label>
              <textarea
                id="requirements"
                v-model="requirements"
                rows="4"
                
              ></textarea>
            </div>
            <div class="text-main">
              <button type="submit"  class="button-box">{{ $t("ServiceProcess26") }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    </div>
    <!-- 海康助农牧云 -->
    <div v-if="activeTab === '海康助农牧云'" >

      <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("product11") }}</div>
         <div class="img-box">
          <img src="../assets/img/soft2.png" class="img-li-two" />
        </div>
      </div>
    </div>

    
     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-one">
          <img src="../assets/img/an24.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("product13") }}</div>
          <p class="solution-title-one">{{ $t("product16") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an25.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("product14") }}</div>
          <p class="solution-title-one">{{ $t("product17") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an26.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("product15") }}</div>
          <p class="solution-title-one">{{ $t("product18") }}</p>
        </div>
      </div>
    </div>

    

 <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("product9") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

       <div class="ServiceProcess-contact">
      <div class="contact-box">
        <div class="mg20">
          <span class="title-two">{{ $t("product10") }}</span>
        </div>
        <div>
          <form @submit.prevent="handleSubmit">
            <div>
              <label for="companyName">{{ $t("ServiceProcess22") }}:</label>
              <input
                type="text"
                id="companyName"
                v-model="companyName"
                
              />
            </div>
            <div>
              <label for="contactPerson">{{ $t("ServiceProcess23") }}:</label>
              <input
                type="text"
                id="contactPerson"
                v-model="contactPerson"
                
              />
            </div>
            <div>
              <label for="contactInfo">{{ $t("ServiceProcess24") }}:</label>
              <input
                type="text"
                id="contactInfo"
                v-model="contactInfo"
                
              />
            </div>
            <div>
              <label for="requirements">{{ $t("ServiceProcess25") }}:</label>
              <textarea
                id="requirements"
                v-model="requirements"
                rows="4"
                
              ></textarea>
            </div>
            <div class="text-main">
              <button type="submit" class="button-box" >{{ $t("ServiceProcess26") }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      activeTab: "轻蜓资产云",
      companyName: "",
      contactPerson: "",
      contactInfo: "",
      requirements: "",
    };
  },
   methods: {
    handleSubmit() {
      // 阻止表单的默认提交行为
      // 这里可以添加进一步的逻辑，比如将表单数据发送到服务器
      console.log({
        companyName: this.companyName,
        contactPerson: this.contactPerson,
        contactInfo: this.contactInfo,
        requirements: this.requirements,
      });

      if(this.companyName.length<=0){
          alert("请输入公司名称");
          return;
      }else if(this.contactPerson.length<=0){
          alert("请输入联系人");
          return;
      }else if(this.contactInfo.length<=0){
          alert("请输入联系方式");
          return;
      }
      
      request.post('/hkbr/customer/webAdd', {
        corporateName: this.companyName,
        contacts: this.contactPerson,
        phone: this.contactInfo,
        content: this.requirements,
        source:this.activeTab == "轻蜓资产云"?"asset":"eartags"
      }).then(data=>{
        console.log(data);
        this.companyName="";
        this.contactPerson="";
        this.contactInfo="";
        this.requirements="";
        alert("提交成功"); // 提示提交成功
      })
    },
  },
};
</script>

<style scoped>
.new-main {
  float: left;
  width: 100%;
}
.news-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.news-tabs button {
  padding: 12px 30px;
  margin: 20px 10px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  font-size: 18px;
  color: #4a4a4a;
}

.news-tabs button.active {
  background-color: #d1261e;
  color: white;
}

.news-list {
  width: 1200px;
  margin: 0 auto;
}
.ServiceProcess-mian {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding: 0 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.one-main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}

.ServiceProcess-box {
  float: left;
  width: 33.33%;
  background: #fff;
  border-right: 1px solid #eee;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
}
.ServiceProcess-title {
  font-size: 24px;
  color: #4a4a4a;
  margin: 20px 0;
}
.ServiceProcess-img {
  width: 170px;
  height: 150px;
}
.ServiceProcess-bottom {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
}
.ServiceProcess-bottom div {
  margin-bottom: 20px;
}
.title-one {
  color: #4a4a4a;
  font-weight: 800;
}
.title-two {
  color: #666;
}

.ServiceProcess-contact {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding: 0 50px 50px 50px;
  box-sizing: border-box;
}
.contact-box {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
input[type="text"],
textarea {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.text-main {
  width: 100%;
  text-align: center;
}
.button-box {
  padding: 10px 15px;
  background-color: #ca391b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.button-box:hover {
  background-color: #ca391b;
}
.mg20 {
  margin-bottom: 20px;
}
@media (max-width: 1200px) {
  .ServiceProcess-mian {
    flex-direction: column;
    padding: 0 10px;
  }
  .ServiceProcess-box {
    width: 100%;
    margin-bottom: 20px;
  }
  .ServiceProcess-title {
    font-size: 18px;
    color: #4a4a4a;
  }
  .ServiceProcess-contact {
    padding: 0 10px;
  }
  .contact-box {
    width: 100%;
  }
  .one-main {
    float: left;
    width: 100%;
  }
}



</style>